import React from "react";
import { Link } from "react-router-dom";
import AboutOne from '../elements/AboutOne';

function AboutSix() {
  return (
    <div>
      <>
        {/* short discription about company area  */}
        <div className="short-discription-area tmp-section-gapBottom" style={{
          paddingTop: '50px',
           
        }}>
          <div className="container  plr_sm--15">
            <div className="row">
              <div className="col-lg-12">
                <div className="short-discription-between-area">
                  <h2
                    className="title wow fadeInUp"
                    data-wow-duration=".8s"
                    data-wow-delay=".1s"
                    style={{
                      fontWeight:"bold"
                    }}
                  >
                    Become Part of Our Community and Elevate Your Business to
                    the  
                    Next Level
                  </h2>
                  <div className="discription-area">
                    <p
                      className="disc wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".1s"
                    >
                      Be part of a dynamic network of entrepreneurs and professionals striving for growth and success. Connect with like-minded individuals, access valuable insights, and unlock opportunities to elevate your business to the next level. Together, we achieve more!
                    </p>
                    {/* <a
                      href="#"
                      className="btn-readmore d-flex wow fadeInUp"
                      data-wow-duration=".8s"
                      data-wow-delay=".3s"
                    >
                      View More
                      <i className="fa-light fa-arrow-right" />
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* short discription about company area end */}

        <AboutOne/>
        {/* about company wrapper */}
        {/* <section className="about-company-area tmp-section-gapBottom">
          <div className="row align-items-center  plr_sm--15 plr_md--15">
            <div className="col-lg-4 offset-lg-2 mb_md--50 mb_sm--30">
              <div className="split-inner">
                <h2
                  className="title sal-animate mb--40 wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".1s"
                >
                  What is V2VBN?
                </h2>
                <p
                  className="description sal-animate mb--25 wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".3s"
                >
                  V2V Business Network (V2VBN) is a professional platform
                  designed to connect entrepreneurs, business leaders, and
                  professionals across industries. Founded by HDH Yadunathji
                  Mahodayshri, V2VBN is rooted in the values of collaboration,
                  growth, and community. Our mission is to create a space where
                  members can share knowledge, build valuable partnerships, and
                  unlock new opportunities for success.
                </p>
                <p
                  className="description sal-animate wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".5s"
                >
                  Whether you’re looking to expand your network, gain insights
                  from industry experts, or discover resources to grow your
                  business, V2VBN offers a supportive environment to help you
                  thrive. With a global reach spanning over 50 countries and a
                  community of more than 5,364 members, we bring together
                  professionals to collaborate and succeed together.
                </p>
                <ul
                  className="split-list sal-animate wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".7s"
                >
                  <li>- Connect Globally</li>
                  <li>- Learn and Grow</li>
                  <li>- Collaborate for Success</li>
                  <li>- Unlock Opportunities</li>
                </ul>
                <div
                  className="view-more-button mt--35 sal-animate d-flex wow fadeInUp"
                  data-wow-duration=".8s"
                  data-wow-delay=".9s"
                >
                  <Link className="tmp-btn btn-primary" to={"/Contact"}>
                    Contact With Us
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 wow fadeInRight"
              data-wow-duration=".8s"
              data-wow-delay=".3s"
            >
              <div className="thumbnail image-right-content">
                <img
                  src="assets/images/about/about-large.jpg"
                  alt="split Images"
                />
              </div>
            </div>
          </div>
        </section> */}
        {/* about company wrapper end */}
      </>
    </div>
  );
}

export default AboutSix;
